import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MotionConfig } from 'framer-motion'
import App from './App'
import { DeviceGate } from './components/DeviceGate'
import './styles/index.css'
import { initFirebase, watchAuthState } from './lib/firebase'
import { initAskaServicesFee } from './lib/askaServices'
import { useApp } from './store'

// Init Firebase + auth-token wiring before the React tree mounts.
// The API client picks up tokens via setAuthTokenProvider inside
// initFirebase, so any fetch issued from a component mount will
// already carry the Bearer header.
//
// Also subscribe to auth state so the store knows whether to blur
// prices (anonymous users never see $ amounts — same guard rail
// the mobile app + Heera assistant enforce).
try {
  initFirebase()
  watchAuthState((user) => {
    useApp.getState().setSignedIn(!!user)
  })
} catch (err) {
  console.warn('Firebase init failed; running in anonymous mode (prices blurred).', err)
}

// Hydrate the concierge fee % from the server (#31) — fire-and-forget; the
// bundled default renders until (and unless) the live value arrives.
initAskaServicesFee()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* Global motion system (spec #8): honour prefers-reduced-motion for
        the whole tree, and set the default ease-out + 180ms so every
        framer transition that omits its own config feels of one hand. */}
    <MotionConfig reducedMotion="user" transition={{ ease: [0.16, 1, 0.3, 1], duration: 0.18 }}>
      <BrowserRouter>
        <App />
        {/* The session gate — device limit, device eviction, and the 401 that
            desktop previously had NO handler for at all (App.tsx has no auth
            gate, so a revoked session kept rendering already-fetched prices and
            supplier contacts). Mounted as a sibling of <App/> rather than
            inside it so it covers BOTH shells — MobileApp renders under App —
            from one place, and so a route-level crash cannot take the gate
            down with it. */}
        <DeviceGate />
      </BrowserRouter>
    </MotionConfig>
  </React.StrictMode>
)
